
import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck';
import { Alert, AlertTitle } from '@material-ui/lab'
import ReportCardV1 from '../form'
import ReportCardV2 from '../formV2'
import { read, utils } from 'xlsx'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'

import { getReportData } from '../../../../data/report-config'

export default function StandardReportStep2({
	quarter,
	flags,
	needToFillFormType,
	currentFilledFormIndex,
	onFillForm,
	fixedGeneralAnswers,
	fixedInfoAnswers,
	fixedSoundAnswers,
	mobileGeneralAnswers,
	mobileInfoAnswers,
	mobileSoundAnswers,
	reportMethod,
	reportVersion,
	excelFile,
	setExcelFile,
	excelFileShow,
	setExcelFileShow,
	userOverride,
	previewAnswers = [],
	setPreviewAnswers,
}) {
	// const [previewAnswers, setPreviewAnswers] = useState([]) -> Moved to parent
	const [activePreviewTab, setActivePreviewTab] = useState(0)

	const handleTabChange = (event, newValue) => {
		setActivePreviewTab(newValue)
	}

	const handleFileUpload = (e) => {
		const file = e.target.files[0]
		if (!file) return

		// Validate file extension
		const fileName = file.name
		const fileExtension = fileName.split('.').pop().toLowerCase()
		if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
			Swal.fire({
				icon: 'error',
				title: 'เกิดข้อผิดพลาด',
				text: 'ไฟล์ไม่ถูกต้อง',
				confirmButtonColor: '#1976d2',
			})
			e.target.value = null // Clear the input
			return
		}

		setExcelFile(file)
		setExcelFileShow(file.name)

		const reader = new FileReader()
		reader.onload = (evt) => {
			const bstr = evt.target.result
			const wb = read(bstr, { type: 'binary' })

			// Validation: Check if there are exactly 8 sheets
			if (wb.SheetNames.length !== 8) {
				Swal.fire({
					icon: 'error',
					title: 'เกิดข้อผิดพลาด',
					// text: 'ไฟล์ต้องมี 8 Sheet เท่านั้น',
					text: 'ไฟล์ไม่ถูกต้อง',
					confirmButtonColor: '#1976d2',
				})
				setExcelFile(null)
				setExcelFileShow('')
				e.target.value = null
				return
			}

			// Validation: Check sheet name prefixes
			const sheetPrefixes = {
				2: '1.1',
				3: '1.2',
				4: '1.3',
				5: '2.1',
				6: '2.2',
				7: '2.3'
			}

			for (let i = 2; i <= 7; i++) {
				if (!wb.SheetNames[i].trim().startsWith(sheetPrefixes[i])) {
					Swal.fire({
						icon: 'error',
						title: 'เกิดข้อผิดพลาด',
						// text: `Sheet ที่ ${i + 1} ต้องขึ้นต้นด้วย ${sheetPrefixes[i]}`,
						text: 'ไฟล์ไม่ถูกต้อง',
						confirmButtonColor: '#1976d2',
					})
					setExcelFile(null)
					setExcelFileShow('')
					e.target.value = null
					return
				}
			}

			// Validation: Check content for specific cells in each sheet
			const contentValidationConfig = [
				{ sheetIndex: 0, cell: 'A1', expected: 'ภาคตะวันออกเฉียงเหนือ' },
				{ sheetIndex: 1, cell: 'A1', expected: 'แบบฟอร์มรายงานค่าชี้วัดคุณภาพบริการรายไตรมาส' },
				{ sheetIndex: 2, cell: 'A2', expected: 'ส่วนที่ 1 ค่าชี้วัดคุณภาพบริการทั่วไป' },
				{ sheetIndex: 3, cell: 'A2', expected: 'ส่วนที่ 2 ค่าชี้วัดคุณภาพบริการประเภทเสียง' },
				{ sheetIndex: 4, cell: 'A2', expected: 'ส่วนที่ 3 ค่าชี้วัดคุณภาพบริการประเภทข้อมูล' },
				{ sheetIndex: 5, cell: 'A2', expected: 'ส่วนที่ 1 ค่าชี้วัดคุณภาพบริการทั่วไป' },
				{ sheetIndex: 6, cell: 'A2', expected: 'ส่วนที่ 2 ค่าชี้วัดคุณภาพบริการประเภทเสียง' },
				{ sheetIndex: 7, cell: 'A2', expected: 'ส่วนที่ 3 ค่าชี้วัดคุณภาพบริการประเภทข้อมูล' }
			]

			for (const config of contentValidationConfig) {
				const wsName = wb.SheetNames[config.sheetIndex]
				const ws = wb.Sheets[wsName]
				const cell = ws[config.cell]
				const cellValue = cell ? String(cell.v) : ''

				if (!cellValue.includes(config.expected)) {
					Swal.fire({
						icon: 'error',
						title: 'เกิดข้อผิดพลาด',
						// text: `Sheet ที่ ${config.sheetIndex + 1} ช่อง ${config.cell} ต้องมีคำว่า "${config.expected}"`,
						text: 'ไฟล์ไม่ถูกต้อง',
						confirmButtonColor: '#1976d2',
					})
					setExcelFile(null)
					setExcelFileShow('')
					e.target.value = null
					return
				}
			}

			// Validation: Check content "Checker" at A210 for sheet index 2 to 7
			let validationFailed = false
			for (let i = 2; i <= 7; i++) {
				const wsName = wb.SheetNames[i]
				const ws = wb.Sheets[wsName]
				const cell = ws['A210']
				const cellValue = cell ? cell.v : ''

				if (cellValue !== 'Checker') {
					// validationFailed = true // will enable next quarter (2026 / Q2)
					break
				}
			}

			if (validationFailed) {
				Swal.fire({
					icon: 'error',
					title: 'เกิดข้อผิดพลาด',
					// text: 'Sheet ที่ 3-8 ต้องมีคำว่า "Checker" ในช่อง A210',
					text: 'ไฟล์ไม่ถูกต้อง',
					confirmButtonColor: '#1976d2',
				})
				setExcelFile(null)
				setExcelFileShow('')
				e.target.value = null
				return
			}

			// Select data details based on version
			const reportData = getReportData(reportVersion)
			const {
				fixed_general_details,
				fixed_sound_details,
				fixed_info_details,
				mobile_general_details,
				mobile_sound_details,
				mobile_info_details
			} = reportData

			const sheetMapping = [
				{ index: 2, details: fixed_general_details, type: 'fixed-general' },
				{ index: 3, details: fixed_sound_details, type: 'fixed-sound' },
				{ index: 4, details: fixed_info_details, type: 'fixed-info' },
				{ index: 5, details: mobile_general_details, type: 'mobile-general' },
				{ index: 6, details: mobile_sound_details, type: 'mobile-sound' },
				{ index: 7, details: mobile_info_details, type: 'mobile-info' },
			]

			let allParsedAnswers = []

			sheetMapping.forEach(({ index, details }) => {
				if (wb.SheetNames.length > index) {
					const wsName = wb.SheetNames[index]
					const ws = wb.Sheets[wsName]

					details.forEach(item => {
						if (item.excelValueCol && item.excelValueRow) {
							const answerItem = {
								DataSetItemID: item.id,
								DataValueMonth1: '',
								DataValueMonth2: '',
								DataValueMonth3: '',
								DataValueMonthAvg: '',
								DataValueExtra: ''
							}

							const getCellValue = (col) => {
								const cellAddress = col + item.excelValueRow
								const cell = ws[cellAddress]
								return cell ? cell.v : ''
							}

							const cols = item.excelValueCol

							// Generic mapping strategy: 
							// Assuming cols are ordered [M1, M2, M3, Avg, Extra]
							if (reportVersion >= 2) {
								const colMap = {}
								cols.forEach(col => { colMap[col] = getCellValue(col) })

								if (cols.length === 5) {
									answerItem.DataValueMonth1 = colMap['F'] || ''
									answerItem.DataValueMonth2 = colMap['G'] || ''
									answerItem.DataValueMonth3 = colMap['H'] || ''
									answerItem.DataValueMonthAvg = colMap['I'] || ''
									answerItem.DataValueExtra = colMap['E'] || ''
								} else if (item.no && item.no.startsWith('2.2.')) {
									answerItem.DataValueMonth1 = colMap['F'] || ''
									answerItem.DataValueMonth2 = colMap['G'] || ''
									answerItem.DataValueMonth3 = colMap['H'] || ''
									answerItem.DataValueMonthAvg = colMap['I'] || ''
								} else {
									answerItem.DataValueMonth1 = colMap['D'] || ''
									answerItem.DataValueMonth2 = colMap['E'] || ''
									answerItem.DataValueMonth3 = colMap['F'] || ''
									answerItem.DataValueMonthAvg = colMap['G'] || ''
								}
							} else {
								if (cols.length >= 1) answerItem.DataValueMonth1 = getCellValue(cols[0])
								if (cols.length >= 2) answerItem.DataValueMonth2 = getCellValue(cols[1])
								if (cols.length >= 3) answerItem.DataValueMonth3 = getCellValue(cols[2])
								if (cols.length >= 4) answerItem.DataValueMonthAvg = getCellValue(cols[3])
								if (cols.length >= 5) answerItem.DataValueExtra = getCellValue(cols[4])
							}

							allParsedAnswers.push(answerItem)
						}
					})
				}
			})
			setPreviewAnswers(allParsedAnswers)
		}
		reader.readAsBinaryString(file)
	}

	return (
		<>
			<Alert severity="info" className="mb-5 w-full" style={{ whiteSpace: "normal" }}><AlertTitle>หากท่านเลือกดำเนินการต่อ แต่ไม่พบข้อมูลในแบบฟอร์ม ท่านอาจจะเลือก ชุดข้อมูลการส่งรายงาน ไม่ตรงกับการกรอกข้อมูลเดิม โปรดเลือกให้ถูกต้องทุกครั้ง</AlertTitle></Alert>
			{reportMethod === 'web-form' ? (
				reportVersion == 2 ? (
					<Grid className="w-full flex flex-col gap-y-6">
						<ReportCardV2
							quarter={quarter}
							flags={flags}
							type={needToFillFormType[currentFilledFormIndex]}
							onFillForm={onFillForm}
							fixedGeneralAnswers={fixedGeneralAnswers}
							fixedInfoAnswers={fixedInfoAnswers}
							fixedSoundAnswers={fixedSoundAnswers}
							mobileGeneralAnswers={mobileGeneralAnswers}
							mobileInfoAnswers={mobileInfoAnswers}
							mobileSoundAnswers={mobileSoundAnswers}
							user={userOverride}
						/>
					</Grid>
				) : (
					<Grid className="w-full flex flex-col gap-y-6">
						<ReportCardV1
							quarter={quarter}
							flags={flags}
							type={needToFillFormType[currentFilledFormIndex]}
							onFillForm={onFillForm}
							fixedGeneralAnswers={fixedGeneralAnswers}
							fixedInfoAnswers={fixedInfoAnswers}
							fixedSoundAnswers={fixedSoundAnswers}
							mobileGeneralAnswers={mobileGeneralAnswers}
							mobileInfoAnswers={mobileInfoAnswers}
							mobileSoundAnswers={mobileSoundAnswers}
							user={userOverride}
						/>
					</Grid>
				)
			) : (
				<Grid className="flex items-center justify-center flex-col">
					<Card className="flex flex-col h-auto p-4 w-full gap-y-2 border border-t-4 border-card_top_border border-l-0 border-r-0 border-b-0">
						<Grid className="flex flex-row font-bold text-sm items-center">
							<PlaylistAddCheck style={{ fontSize: 22 }} className="mr-1" />
							<Grid className="text-card_header_color">อัพโหลดไฟล์</Grid>
						</Grid>
						<Grid>
							<Divider />
						</Grid>
						<Grid className="mt-4 font-bold">
							* อัพโหลดไฟล์ข้อมูลใน format .xls, .xlsx เท่านั้น *
						</Grid>
						<Grid className="flex flex-row items-center ml-10 my-1">
							<Button variant="contained" component="label" size="small">
								Choose file
								<input
									id="excelFile"
									type="file"
									hidden
									accept=".xlsx, .xls"
									onChange={handleFileUpload}
								/>
							</Button>
							<Grid className="ml-2">{excelFileShow}</Grid>
						</Grid>
					</Card>

					{previewAnswers.length > 0 && (
						<Grid className="w-full flex flex-col gap-y-6 mt-6">
							<div className="text-lg font-bold">ตัวอย่างข้อมูลจากไฟล์ (Preview)</div>

							<AppBar position="static" color="default">
								<Tabs
									value={activePreviewTab}
									onChange={handleTabChange}
									indicatorColor="primary"
									textColor="primary"
									variant="scrollable"
									scrollButtons="auto"
								>
									{needToFillFormType.map((type, index) => {
										let label = type
										if (type === 'fixed-general') label = 'ประจำที่: ทั่วไป'
										else if (type === 'fixed-sound') label = 'ประจำที่: เสียง'
										else if (type === 'fixed-info') label = 'ประจำที่: ข้อมูล'
										else if (type === 'mobile-general') label = 'เคลื่อนที่: ทั่วไป'
										else if (type === 'mobile-sound') label = 'เคลื่อนที่: เสียง'
										else if (type === 'mobile-info') label = 'เคลื่อนที่: ข้อมูล'

										if (type === 'fixed-sound' && !userOverride?.isUseReport1_1_2) return null;

										return <Tab label={label} key={index} />
									})}
								</Tabs>
							</AppBar>

							{needToFillFormType.map((type, index) => {
								if (type === 'fixed-sound' && !userOverride?.isUseReport1_1_2) return null;

								return (
									<div
										role="tabpanel"
										hidden={activePreviewTab !== index}
										id={`simple-tabpanel-${index}`}
										aria-labelledby={`simple-tab-${index}`}
										key={index}
									>
										{activePreviewTab === index && (
											<Box p={3}>
												{reportVersion == 2 || reportVersion > 1 ? (
													<ReportCardV2
														quarter={quarter}
														flags={flags}
														type={type}
														onFillForm={() => { }}
														fixedGeneralAnswers={previewAnswers}
														fixedInfoAnswers={previewAnswers}
														fixedSoundAnswers={previewAnswers}
														mobileGeneralAnswers={previewAnswers}
														mobileInfoAnswers={previewAnswers}
														mobileSoundAnswers={previewAnswers}
														user={userOverride}
													/>
												) : (
													<ReportCardV1
														quarter={quarter}
														flags={flags}
														type={type}
														onFillForm={() => { }}
														fixedGeneralAnswers={previewAnswers}
														fixedInfoAnswers={previewAnswers}
														fixedSoundAnswers={previewAnswers}
														mobileGeneralAnswers={previewAnswers}
														mobileInfoAnswers={previewAnswers}
														mobileSoundAnswers={previewAnswers}
														user={userOverride}
													/>
												)}
											</Box>
										)}
									</div>
								)
							})}
						</Grid>
					)}
				</Grid>
			)}
		</>
	)
}
